import React from 'react'
import {connect} from 'react-redux'

import {
  ROLES,
  SESSION_STATUSES
} from '../shared/config/constants'

import formatSummaryDateTime from '../shared/data/formatters/summary_date_time'
import isSessionOnTime from '../shared/data/helpers/is_session_on_time'
import showModal from '../shared/data/actions/show_modal'

import ProfileImage from '../shared/profile_image'
import ExpertRating from '../shared/expert_rating'
import ExpertSessionsCount from '../shared/expert_sessions_count'
import ConversationMessageInformer from './conversation_message_informer'
import GoToSessionButton from './go_to_session_button'
import ContinueCheckoutSessionButton from '../shared/continue_checkout_session_button'

class SessionInfoMessageInformer extends React.Component {
  constructor (props) {
    super(props)

    this.state = {}

    this.onRequestSession = this.onRequestSession.bind(this)
  }

  onRequestSession (e) {
    if (e && e.preventDefault) e.preventDefault()

    this.props.showInitiateSessionModal({
      type: 'sessionInitiate',
      props: {expert: this.props.user}
    })
  }

  render () {
    if (!this.props.currentSession) return false

    const startTime = this.props.currentSession.get('startTime')
    const status = this.props.currentSession.get('status')

    if (this.props.currentUser.get('role') === ROLES.EXPERT) {
      if (status === SESSION_STATUSES.PAID && isSessionOnTime(startTime)) {
        return (
          <ConversationMessageInformer>
            <div className='informer-section'>
              You are in paid session with this user.
            </div>
            <div className='action-area'>
              <GoToSessionButton sessionId={this.props.sessionId}/>
            </div>
          </ConversationMessageInformer>
        )
      }
      else if (status === SESSION_STATUSES.INITIATED) {
        return (
          <ConversationMessageInformer>
            <div className='informer-section'>
              User is about to complete checkout. Give user a moment.
            </div>
          </ConversationMessageInformer>
        )
      }
      else {
        return (
          <ConversationMessageInformer>
            <div className='informer-section'>
              Your closest session with this user is on<br/>
              <b>{formatSummaryDateTime(startTime)}</b>.
            </div>
          </ConversationMessageInformer>
        )
      }
    }
    else {
      if (status === SESSION_STATUSES.PAID && isSessionOnTime(startTime)) {
        return (
          <ConversationMessageInformer>
            <div className='informer-section'>
              <ProfileImage user={this.props.user} image={this.props.user.profileImage} size={64}/>
            </div>
            <div className='informer-section' style={{fontSize: '20px'}}>
              <ExpertRating rating={this.props.user.rating}/>
            </div>
            <div className='informer-section' style={{fontSize: '14px'}}>
              <ExpertSessionsCount uid={this.props.user.uid} size={16} />
              <p>sessions so far</p>
            </div>
            <div className='informer-section'>
              You are in paid session with this expert.
            </div>
            <div className='action-area'>
              <GoToSessionButton sessionId={this.props.sessionId}/>
            </div>
          </ConversationMessageInformer>
        )
      }
      else if (status === SESSION_STATUSES.INITIATED) {
        return (
          <ConversationMessageInformer>
            <div className='informer-section'>
              <ProfileImage user={this.props.user} image={this.props.user.profileImage} size={64}/>
            </div>
            <div className='informer-section' style={{fontSize: '20px'}}>
              <ExpertRating rating={this.props.user.rating}/>
            </div>
            <div className='informer-section' style={{fontSize: '14px'}}>
              <ExpertSessionsCount uid={this.props.user.uid} size={16} />
              <p>sessions so far</p>
            </div>
            <div className='informer-section'>
              You are about to complete checkout steps for a session with this expert.
            </div>
            <div className='action-area'>
              <ContinueCheckoutSessionButton
                sessionId={this.props.sessionId}
                session={this.props.currentSession}
                expert={this.props.user}/>
            </div>
          </ConversationMessageInformer>
        )
      }
      else {
        return (
          <ConversationMessageInformer>
            <div className='informer-section'>
              <ProfileImage user={this.props.user} image={this.props.user.profileImage} size={64}/>
            </div>
            <div className='informer-section' style={{fontSize: '20px'}}>
              <ExpertRating rating={this.props.user.rating}/>
            </div>
            <div className='informer-section' style={{fontSize: '14px'}}>
              <ExpertSessionsCount uid={this.props.user.uid} size={16} />
              <p>sessions so far</p>
            </div>
            <div className='informer-section'>
              Your closest session with this expert is on <br/>
              <b>{formatSummaryDateTime(startTime)}.</b><br/>
            </div>
            <div className='action-area'>
              <a href='#' className='button success' onClick={this.onRequestSession}>Request another session</a>
            </div>
          </ConversationMessageInformer>
        )
      }
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentUser: state.get('currentUser'),
    currentSession: state.getIn(['sessions', 'experts', ownProps.sessionId])
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showInitiateSessionModal: (modal) => dispatch(showModal(modal))
  }
}

const SessionInfoMessageInformerContainer = connect(
  mapStateToProps, mapDispatchToProps
)(SessionInfoMessageInformer)

export default SessionInfoMessageInformerContainer



/** WEBPACK FOOTER **
 ** ./modules/chat_ui/session_info_message_informer.js
 **/